import React from 'react';

const SOCIAL = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/synesthetic_ca/',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    name: 'X',
    href: 'https://x.com/Synesthetic_ca',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.727-8.929L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
      </svg>
    ),
  },
  {
    name: 'Reddit',
    href: 'https://www.reddit.com/user/synesthetic_ca/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.28 7.7c.2 0 .39.03.57.09a1.58 1.58 0 0 1-.1 1.17c.1.2.16.43.16.67 0 1.63-1.87 2.96-4.17 3.23.34.58.88 1.05 1.58 1.35-.14.18-.41.26-.7.2-.62-.12-1.23-.34-1.77-.65-.53.17-1.1.26-1.7.26-.59 0-1.15-.09-1.68-.25a5.3 5.3 0 0 1-1.78.65c-.29.06-.56-.02-.7-.2.7-.3 1.24-.77 1.58-1.35-2.3-.27-4.17-1.6-4.17-3.23 0-.24.06-.47.16-.67a1.58 1.58 0 0 1-.1-1.17c.18-.06.37-.09.57-.09.7 0 1.32.3 1.75.77C8.07 9.2 9.92 8.7 12 8.7c2.08 0 3.93.5 5.53 1.27.43-.47 1.05-.77 1.75-.77zM8.9 13.2c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm6.2 1.95c-.55.55-1.55.82-3.1.82s-2.55-.27-3.1-.82a.37.37 0 0 1 0-.53.37.37 0 0 1 .53 0c.4.4 1.2.62 2.57.62s2.17-.22 2.57-.62a.37.37 0 0 1 .53 0c.14.14.14.39 0 .53zm-.2-.95c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
      </svg>
    ),
  },
];

export const SocialLinks = ({ className = '', label }) => (
  <div className={`social-links ${className}`.trim()}>
    {label ? <p className="social-links-label">{label}</p> : null}
    <div className="social-links-row" role="list">
      {SOCIAL.map((item) => (
        <a
          key={item.name}
          href={item.href}
          className="social-link"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.name}
          title={item.name}
          role="listitem"
        >
          {item.icon}
        </a>
      ))}
    </div>
  </div>
);

export const SOCIAL_PROFILES = SOCIAL;
